<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("damages_item_list") }}</h4>
        </div>
      </div>

      <div v-if="can('inventory.damage_item', 'W')" class="page-btn">
        <router-link to="/damage/item" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("new_damage") }}
        </router-link>
      </div>
    </div>

    <ThemeDataTable
      ref="damageTable"
      table-id="DamageItemTable"
      :fetch-data="fetchDamagesPage"
      :filters="tableFilters"
      default-order-dir="desc"
    >
      <template #default="{ rows }">
        <thead class="thead-light">
          <tr>
            <th>{{ $t("damage_voucher_no") }}</th>
            <th>{{ $t("damage_voucher_date") }}</th>
            <th class="no-sort">{{ $t("item_name") }}</th>
            <th>{{ $t("costing_unit_price") }}</th>
            <th>{{ $t("damage_qty") }}</th>
            <th>{{ $t("total_damage_amount") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ret in rows" :key="ret.id">
            <td>{{ ret.damage_voucher }}</td>
            <td>{{ ret.damage_voucher_date }}</td>
            <td>
              <div class="d-flex align-items-center">
                <span class="avatar avatar-md me-2">
                  <img
                    v-if="ret.image"
                    :src="$getImageUrl(ret.image)"
                    alt="Item Image"
                  />
                  <span
                    v-else
                    class="avatar-title rounded bg-light text-secondary d-flex align-items-center justify-content-center w-100 h-100"
                  >
                    <i class="ti ti-photo"></i>
                  </span>
                </span>
                <div class="d-flex flex-column">
                  <span>{{ ret.item_name }}</span>
                  <small
                    v-if="ret.serial_number"
                    class="text-muted"
                  >
                    {{ $t('serial_number') }}: {{ ret.serial_number }}
                  </small>
                </div>
              </div>
            </td>
            <td>{{ formatMoney(ret.unit_price) }}</td>
            <td>{{ ret.damage_qty }}</td>
            <td>{{ formatMoney(ret.total_damage_price) }}</td>
          </tr>
        </tbody>
      </template>
    </ThemeDataTable>
  </div>
</template>

<script>
import { can as canAccess } from "@/helpers/permission";
import apiUrls from '@/urls';
import ThemeDataTable from '@/components/common/ThemeDataTable.vue';
import { truncateMoney2 } from '@/utils';

export default {
  components: {
    ThemeDataTable,
  },
  data() {
    return {
      filterOptions: {
        category: [],
        warehouse: [],
      },
    };
  },
  computed: {
    tableFilters() {
      return [
        {
          key: 'category',
          label: this.$t('category'),
          options: this.filterOptions.category,
        },
        {
          key: 'warehouse',
          label: this.$t('warehouse'),
          options: this.filterOptions.warehouse,
        },
      ];
    },
  },
  methods: {
    formatMoney(amount) {
      return truncateMoney2(amount);
    },

    async fetchFilterOptions() {
      try {
        const [categoriesRes, warehousesRes] = await Promise.all([
          this.$axios.get(apiUrls.categories.get),
          this.$axios.get(apiUrls.inventory_warehouse.get),
        ]);
        this.filterOptions.category = (categoriesRes?.data || [])
          .map((c) => c.node || c.name)
          .filter(Boolean);
        this.filterOptions.warehouse = (warehousesRes?.data || [])
          .map((w) => w.name)
          .filter(Boolean);
      } catch (error) {
        console.error('Error fetching damage filter options:', error);
      }
    },

    async fetchDamagesPage({ draw, start, length, search, orderColumn, orderDir, filters }) {
      const params = {
        draw,
        start,
        length,
        'search[value]': search || '',
        'order[0][column]': orderColumn,
        'order[0][dir]': orderDir,
        ...filters,
      };

      const response = await this.$axios.get(apiUrls.damage_item.get, { params });
      const payload = response.data || {};

      return {
        data: payload.data || [],
        recordsTotal: payload.recordsTotal || 0,
        recordsFiltered: payload.recordsFiltered || 0,
      };
    },

    can(code, requiredLevel) {
      return canAccess(code, requiredLevel);
    },
  },
  created() {
    this.fetchFilterOptions();
  },
};
</script>
